var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.167,
    stroke: "#919191",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#919191",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 9.167v5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 5.833,
    r: 1,
    fill: "#919191",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpGrey);
export default __webpack_public_path__ + "static/media/help-grey.de40cdc320f654c87a66e7461f42eb14.svg";
export { ForwardRef as ReactComponent };